<template>
  <div :style="dependenciesComponentsStyleList">
    <span
      class="ui-icon-circle-close error--text mx-auto mb-3 d-block"
      :style="canceledIconStyleList"
    />
    <div class="text-body-1 text--text text-center">
      <slot name="club-error-html" />
    </div>
    <button
      type="button"
      class="b-button b-button_light mb-4 mt-6"
      :class="buttonDeviceClassList"
      @click="handleReturnFromErrorView"
    >
      <span class="text-button primary--text">
        Вернуться
      </span>
    </button>
  </div>
</template>

<script>
import {
  ClubStyleData,
  ClubGlobalData,
  ClubCommonData,
  ClubEventsNames,
} from 'www/vue_components/common/Club/mixins'

export default {
  name: 'ClubAppointmentError',
  mixins: [
    ClubStyleData,
    ClubGlobalData,
    ClubCommonData,
    ClubEventsNames,
  ],
  methods: {
    handleReturnFromErrorView(event) {
      this.$emit(this.eventClubReturnFromErrorView, { event })
    },
  },
}
</script>
